"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var makeQueryString_1 = __importDefault(require("./makeQueryString"));
var addParamsToHash = function (url, params) {
    if (params === void 0) { params = {}; }
    var queryString = makeQueryString_1.default(params);
    return url + "#" + queryString;
};
exports.default = addParamsToHash;
